import { ICopyable } from '../controls/common/icopyable';
import { EmailAddress } from './email-address';
import { ChannelType } from './enums/channel-type';
import { IChannel } from './interfaces/channel.interface';

export class Channel implements ICopyable<Channel> {
    id: number = null;
    channelType: ChannelType = null;
    addressId: string = null;
    address: EmailAddress = null;
    ocrEnabled: boolean = false;
    customerIdentificationEnabled: boolean = false;
    documentIdentificationEnabled: boolean = false;
    attributesAssignmentEnabled: boolean = false;
    ladEnabled: boolean = false;
    autoLinkEnabled: boolean = false;
    defaultBoxId: string = null;
    defaultStateId: number = null;
    viewId: number = null;

    public createCopy(): Channel {
        const instance = new Channel();
        instance.id = this.id;
        instance.channelType = this.channelType;
        instance.addressId = this.addressId;
        instance.address = this.address;
        instance.ocrEnabled = this.ocrEnabled;
        instance.customerIdentificationEnabled = this.customerIdentificationEnabled;
        instance.documentIdentificationEnabled = this.documentIdentificationEnabled;
        instance.attributesAssignmentEnabled = this.attributesAssignmentEnabled;
        instance.ladEnabled = this.ladEnabled;
        instance.autoLinkEnabled = this.autoLinkEnabled;
        instance.defaultBoxId = this.defaultBoxId;
        instance.viewId = this.viewId;
        instance.defaultStateId = this.defaultStateId;

        return instance;
    }

    public static createFormCopy(channel: Channel): IChannel {
        const instance = new Channel();
        instance.id = channel.id;
        instance.channelType = channel.channelType;
        instance.addressId = channel.addressId;
        instance.address = channel.address;
        instance.ocrEnabled = channel.ocrEnabled;
        instance.customerIdentificationEnabled = channel.customerIdentificationEnabled;
        instance.documentIdentificationEnabled = channel.documentIdentificationEnabled;
        instance.attributesAssignmentEnabled = channel.attributesAssignmentEnabled;
        instance.ladEnabled = channel.ladEnabled;
        instance.autoLinkEnabled = channel.autoLinkEnabled;
        instance.defaultBoxId = channel.defaultBoxId;
        instance.viewId = channel.viewId;
        instance.defaultStateId = channel.defaultStateId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        if (other.channelType == 1) {
            this.channelType = ChannelType.Fax;
        } else if (other.channelType == 2) {
            this.channelType = ChannelType.Email;
        } else if (other.channelType == 3) {
            this.channelType = ChannelType.Sms;
        } else if (other.channelType == 4) {
            this.channelType = ChannelType.Vocal;
        } else if (other.channelType == 5) {
            this.channelType = ChannelType.Chat;
        }
        this.addressId = other.addressId;
        this.address = other.address;
        this.ocrEnabled = other.ocrEnabled;
        this.customerIdentificationEnabled = other.customerIdentificationEnabled;
        this.documentIdentificationEnabled = other.documentIdentificationEnabled;
        this.attributesAssignmentEnabled = other.attributesAssignmentEnabled;
        this.ladEnabled = other.ladEnabled;
        this.autoLinkEnabled = other.autoLinkEnabled;
        this.defaultBoxId = other.defaultBoxId;
        this.viewId = other.viewId;
        this.defaultStateId = other.defaultStateId;
    }

    public getDisplayName() {
        if (this.address) {
            return `${this.address.address}`;
        } else {
            return '';
        }
    }
}
